module.exports = __webpack_public_path__ + "img/floor7.a0a33793.jpg";